<template>

      <el-dialog
            title="批量导入"
            :visible="true"
            width="50%"
          
            :append-to-body=true
            :before-upload='beforeUpload'
            :before-close="handleClose">
            <div class='import'>
                   <el-upload
            ref='upload'
            class="upload-demo"
            :action="url"
             name="putaway_file"
            :on-change="handleChange"
            :auto-upload='false'
            :on-success="success"
            :on-error="error"
             :multiple=true
             :headers='headers'
            :file-list="fileList"
            >
             <!--  -->
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">（一次最多可导入100条）</div>
            </el-upload>
            <p>模板下载:</p>
            <div class="tips" @click='down(1)' >
                
                <a href="javascript:;" download> 通用商品批量导入模板下载.xls</a>
            </div>
        
            <p>注:</p>
            <p>
                1.商品编号、商品名称、是否赠品、经销商级别编号、经销商级别为必填项，其他选填，但商品价格至少填写一个
            </p>
            <p>2.如果填写的是赠品，无需再填写商品属性</p>
            <p>
                3.如果导入的商品与已经上架的商品重复，则会更新已上架的商品
            </p>
            <el-button size="small" type="primary" @click='importData'>上传</el-button>
            <el-button size="small" type="primary" @click='reset'>重置</el-button>

            </div>
            <importDetail  v-if='detail' :table='table' v-on:handleClose='detail=false' @refresh='refresh'/>
      </el-dialog>
</template>

<script>
import importDetail from './importDetail'
export default {
    data(){
        return{
            table:{},
            url:'',
            detail:false,
            fileList:[],
            file:{},
            headers: {
                    // 'Content-Type': 'multipart/form-data'  //之前说的以表单传数据的格式来传递fromdata
            }
        }
    },
    props:{
        importType:String
    },
    methods:{
          init(){
            // this.$get('logistics','/product.putaways.template').then(res=>{
            //     this.downLink=res.data
            // })
        },
        handleClose(){
            this.$emit('handleClose')
        },
        down(type){
           let url = '',access_tokens = localStorage.getItem('access_tokens');
               if(type==1){
                    window.open(this.$Base_Export
                    + '/product.putaways.template?is_export=1&signature=' + this.$md5(access_tokens)
                )
               }else{
                     window.open(this.$Base_Export
                    + '/specify.putaways.template?is_export=1&signature=' + this.$md5(access_tokens)
                )
               }
        },
        reset(){
            this.fileList=[]
        },
        handleChange(value,valueList){
            console.log(value,valueList[0])
            if(valueList.length>1){
                valueList.splice(0,1)
            }
            this.fileList=valueList
            this.file=value
        },
        refresh(){
                this.$emit('handleClose');
                  this.$emit('refresh');
                this.detail=false
        },
        importData(){
           
               if(process.env.NODE_ENV == 'development'){
                    this.url = 'http://logistics.c.'+process.env.VUE_APP_URL;
                }else if(process.env.NODE_ENV == 'production'){
                    this.url = 'http://logistics.'+process.env.VUE_APP_URL;
                }else{
                    this.url = 'http://logistics.c.'+process.env.VUE_APP_URL;
                }
                 this.url+='/product.putaways.import'
                //  this.headers.Authorization='Bearer' + " " +'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg2MWFkZTk2OGZhM2RlODFhZmY4ZGY1MTBhNGZiZmM2ZDE4ZDE5NjU2ZWRkNWYyNDAyN2JiNjQ4ZjAxYTg4OTI4MTNkMzI1OTBjODUzOTMyIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6Ijg2MWFkZTk2OGZhM2RlODFhZmY4ZGY1MTBhNGZiZmM2ZDE4ZDE5NjU2ZWRkNWYyNDAyN2JiNjQ4ZjAxYTg4OTI4MTNkMzI1OTBjODUzOTMyIiwiaWF0IjoxNTYyNzU5MjczLCJuYmYiOjE1NjI3NTkyNzMsImV4cCI6MTU2NDA1NTI3Mywic3ViIjoiMjIiLCJzY29wZXMiOlsiKiJdfQ.NsIp_fAqXcOn4osyLQ6fTxVTiqUt2ah9LL30AJnWoBdmDTOerX5myrW75Vtkz1obu8XhwA2zKzz1Toy1jDfeWC0DmpK7R6LvqeumckjombxVK979uCQHu3l0InUJ25_IiD99Br9oSNEIV2zIUGaQsCmxqCmOzgEwn8AYX2PyQamcZLFhew-F-aOUDYvHWoduXV401gtCOAEDZR5LbJsLSZJ00rp06qg-QkXiQYwYRQ90rRJXyL3BHII1Bl9bmzLRZ_LD_EHA_BLN_6ZSdAuzqLHh5UK6P2Q1UNkM0YH8LOIiMpVneWjlpkhI55GBZfTTPkCu5HLE7GXx4bjZk5En99vtLUYR8ACcaJeY4a1LjH8SCvaDKcj3eVk8OpPD4-P3qzT6rmyOceymCxzqVMXknZO0PN3yjEg9-KJiHCIQIXJ3Qy_rR1eq5gxLhYmYmkKNxwS8HEcttyezj1M93YG3ewB0cAJA9O9DL2RwY2jhTnQel3UAzG0vjnEK_oH-SctRse38pMt6F_yyDa2EO22utHrysCSI7rRVA9xADFUth2C333cPsmZ2dmKxup_hZGlncINxjs8hUQQ_jWDmNrELe2fm9_n13uvVVeIYmeqs4H9l7Z2uZxWZOr7kNYF3FUTa37hp2LiOt8hCvuCc9qDbE8ur-Ed9BbR5rzTZltgGIo4';
               this.headers.Authorization ='Bearer' + " " +localStorage.getItem('access_tokens');
                var that=this

           setTimeout(() => {
                 that.$refs.upload.submit();
              
                // this.table=
           }, 150);
           
        },
        error(error){
                  this.$message({
                    type:'error',
                    message:'上传失败'
                })
        },
        success(res){
                 
            if(res.data.total_failure==0){
                this.$message({
                    type:'success',
                    message:'导入成功'
                })
                this.$emit('handleClose');
                  this.$emit('refresh');
            }else{
                this.table=res.data
             this.detail=true
        
            }
            
        },
        beforeUpload(value){
            console.log(value)
        },

    },
    components:{
        importDetail
    },
    created(){
        this.init()
    }
}
</script>
<style lang="scss" scoped>
.import{
    line-height: 22px;
    .tips{

        a{
        color: #f04635

        }
    }
    p{
        margin-bottom: 10px;
    }
}

</style>


